/* Balkan — panoul de alegere rapida de pe cardul de produs.

   Cerinta clientului (14 sept. 2026, referinta transylvanianutrition): butonul
   ramane „Alege optiunile", in culoarea butonului de cos; la apasare se deschide
   PESTE CARD un panou cu titlul, pretul, grupele de optiuni, „Adauga in cos" si
   „Vezi detalii complete". Nu mai e nevoie de drum pana la pagina de produs.

   Varianta se rezolva din COMBINATIA de valori alese, nu dintr-un singur buton:
   asa merge si la un produs cu doua optiuni (Aroma + Gramaj), chiar daca azi
   toate produsele cu variante au doar „Aroma".

   Preturile NU se calculeaza aici: vin gata formatate cu filtrul `money` din
   Liquid, in blocul JSON al panoului. Un pret formatat in JS ar putea arata
   altfel decat restul magazinului.

   Delegat pe document: rafturile se re-randeaza prin Section Rendering API cand
   se schimba categoria, iar listenerii pusi pe carduri ar disparea cu ele. */
(() => {
  if (window.__bkCardOptReady) return;
  window.__bkCardOptReady = true;

  const parse = (panel) => {
    if (panel.__vars) return panel.__vars;
    const tag = panel.querySelector('[data-bk-qa-variants]');
    try { panel.__vars = JSON.parse(tag.textContent); } catch { panel.__vars = []; }
    return panel.__vars;
  };

  /** Valorile alese, in ordinea grupelor. */
  const chosen = (panel) =>
    [...panel.querySelectorAll('[data-bk-qa-group]')].map((g) => {
      const on = g.querySelector('.bk-qa__v.is-on');
      return on ? on.dataset.bkQaVal : null;
    });

  const sync = (panel) => {
    const vals = chosen(panel);
    const v = parse(panel).find((x) => x.opts.every((o, i) => o === vals[i]));

    const price = panel.querySelector('[data-bk-price]');
    const list = panel.querySelector('[data-bk-list]');
    const wrap = panel.querySelector('.bk-qa__p');
    const input = panel.querySelector('input[ref="variantId"]');
    const btn = panel.querySelector('.bk-qa__foot button[type="submit"], .bk-qa__foot .bk-btn');

    if (!v) {
      // combinatie inexistenta: nu inventam un pret, doar blocam adaugarea
      if (btn) { btn.disabled = true; btn.dataset.bkOld ||= btn.textContent; btn.textContent = 'Indisponibil'; }
      return;
    }
    if (input) input.value = v.id;
    /* GRUP DE AROME (6 oct. 2026): fiecare „optiune" e alt PRODUS, deci linkul
       „Vezi detalii complete" trebuie sa duca la aroma aleasa, nu la cea
       implicita. `url` vine doar pe cardurile de grup; la variantele obisnuite
       lipseste si linkul ramane neatins. */
    if (v.url) {
      const more = panel.querySelector('.bk-qa__more');
      if (more) more.href = v.url;
    }
    if (price) price.textContent = v.price;
    if (list) { list.textContent = v.list || ''; list.hidden = !v.list; }
    if (wrap) wrap.classList.toggle('bk-pc__price--sale', !!v.list);
    if (btn) {
      btn.disabled = !v.ok;
      if (btn.dataset.bkOld) btn.textContent = v.ok ? btn.dataset.bkOld : 'Stoc epuizat';
      else if (!v.ok) { btn.dataset.bkOld = btn.textContent; btn.textContent = 'Stoc epuizat'; }
    }
  };

  const setOpen = (card, on) => {
    /* panoul vine dintr-un <template> (performanță, 15 oct. 2026): îl punem în pagină
       la prima deschidere, pe locul șablonului — aceeași poziție în card ca înainte */
    if (on) {
      const tpl = card.querySelector('template[data-bk-qa-tpl]');
      if (tpl) tpl.replaceWith(tpl.content.cloneNode(true));
    }
    const panel = card.querySelector('[data-bk-qa]');
    const trigger = card.querySelector('[data-bk-quick]');
    if (!panel) return;
    panel.hidden = !on;
    card.classList.toggle('bk-pc--qa', on);
    if (trigger) trigger.setAttribute('aria-expanded', String(on));
    if (on) {
      // un singur panou deschis o data — doua panouri suprapuse pe acelasi raft
      // ar acoperi cardurile vecine
      document.querySelectorAll('.bk-pc--qa').forEach((c) => { if (c !== card) setOpen(c, false); });
      sync(panel);
      const x = panel.querySelector('[data-bk-qa-close]');
      if (x) x.focus({ preventScroll: true });
    } else if (trigger) {
      trigger.focus({ preventScroll: true });
    }
  };

  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-bk-quick]');
    if (open) { e.preventDefault(); setOpen(open.closest('.bk-pc'), true); return; }

    const close = e.target.closest('[data-bk-qa-close]');
    if (close) { e.preventDefault(); setOpen(close.closest('.bk-pc'), false); return; }

    const val = e.target.closest('[data-bk-qa-val]');
    if (val) {
      e.preventDefault();
      const group = val.closest('[data-bk-qa-group]');
      group.querySelectorAll('[data-bk-qa-val]').forEach((b) => {
        const on = b === val;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', String(on));
      });
      const cur = group.querySelector('[data-bk-qa-cur]');
      if (cur) cur.textContent = val.dataset.bkQaVal;
      sync(val.closest('[data-bk-qa]'));
      return;
    }

    // click in afara panoului deschis -> se inchide
    const inside = e.target.closest('[data-bk-qa]');
    if (!inside) document.querySelectorAll('.bk-pc--qa').forEach((c) => setOpen(c, false));
  });

  addEventListener('keydown', (e) => {
    if (e.key === 'Escape') document.querySelectorAll('.bk-pc--qa').forEach((c) => setOpen(c, false));
  });
})();
